import { ApiService } from '../../services/api_service';
import { DataService } from '../../services/data_service';
import { getCO2Scope3Auswahl } from '../../bereiche/dateneingabe/functions/getCO2Scope3Auswahl';
import { getCO2Scope3StructureAllgemein, getCO2Scope3StructureNachgelagert, getCO2Scope3StructureVorgelagert } from '../../bereiche/dateneingabe/functions/getCO2Scope3Structure';
import { IDs } from '../../helpers/IDs';
import { TriggerService } from '../../core/trigger/trigger_service';
import { Validierung } from '../../bereiche/datenauswertung/elements/Validierung';

let IS_WRITING: boolean = false;

async function getData(entity: string, filter: any, settings: any, dataService: DataService): Promise<any[]> {
    // console.log('getData started...', entity);
    return (await dataService.async_loadData(entity, filter, settings, IDs.MOD_ETOOL_ADMIN) || {})[entity] || [];
}

function getScope3Structures(data: any): any[] {
    const bereich_key: string = ApiService.bereichKey || data[IDs.ENT_KONFIGURATION]?.[0]?.bereich_key_orig || null;
    // const modul: string = data.MODUL_SELECTED || data[IDs.ENT_KONFIGURATION]?.[0]?.dateneingabe_variante || null;
    const modul: string = 'cfm';

    return [
        ...getCO2Scope3StructureVorgelagert(bereich_key, modul) || [],
        ...getCO2Scope3StructureNachgelagert(bereich_key, modul) || [],
        ...getCO2Scope3StructureAllgemein() || [],
    ];
}

function getValidierung(data: any): any {
    const entities: string[] = [
        IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_EIGENSTROM, IDs.ENT_ENERGIEDATEN_WAERME, IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE,
        IDs.ENT_KLIMAGASE, IDs.ENT_STANDORT
    ];

    return new Validierung(
        data,
        null,
        entities.map((entity) => { return { entity }; }),
        'jahr'
    ).getData();
}

export async function processKennzahlenExport(data: any, dataService: DataService, triggerService: TriggerService, callback?: () => void): Promise<void> {
    const delData = (items: any[]): void => {
        dataService.delDataList(IDs.ENT_VSME_EXPORT, items, () => {
            data[IDs.ENT_VSME_EXPORT] = null;
            triggerService.fire('reload', IDs.ENT_VSME_EXPORT);
            onProcessDone();
        });
    };
    const onProcessDone = (): void => {
        IS_WRITING = false;
        if (typeof callback === 'function') {
            callback();
        }
    };
    data = data || {};

    if (IS_WRITING || typeof data[IDs.KENNZIFFERN_STRUKTURIERT] === 'undefined' || !Array.isArray(data[IDs.ENT_VSME_EXPORT])) {
        // console.log('processKennzahlenExport -> Ausstieg!', IS_WRITING, JSON.stringify(data[IDs.KENNZIFFERN_STRUKTURIERT]), JSON.stringify(data[IDs.ENT_VSME_EXPORT]));
        return;
    }

    if (!ApiService.unternehmenInternal) {
        // console.log('processKennzahlenExport', 'no unternehmenInternal');
        onProcessDone();
        return;
    }
    const hasScope3: boolean = data[IDs.ENT_KONFIGURATION]?.[0]?.co2_fussabdruck_orig === 1;
    const delList: any[] = [];
    const externalAccess: any[] = data[IDs.ENT_EXTERNAL_ACCESS] || await getData(IDs.ENT_EXTERNAL_ACCESS, null, {}, dataService);
    const isAvailable: any = {};
    const kennziffern: any = data[IDs.KENNZIFFERN_BERECHNET] || {};
    const kennziffern_standort: any = data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {};
    const kennziffern_strukturiert: any = data[IDs.KENNZIFFERN_STRUKTURIERT] || {};
    const keys: string[] = [
        'strom_verbrauch_einkauf_renewable',
        // 'strom_verbrauch_regenerativ',
        // 'verbrauch_biomasse',
        // 'strom_verbrauch_gesamt',
        'strom_verbrauch_einkauf',
        'eigenstrom_verbrauch',
        'eigenstrom_verbrauch_temp',
        'verbrauch_brennstoffe',
        'verbrauch_brennstoffe_erneuerbar',
        'verbrauch_brennstoffe_gesamt',
        // 'strom_verbrauch_regenerativ',
        'strom_verbrauch_einkauf_gesamt',
        'eigenstrom_verbrauch_gesamt',
        // 'strom_verbrauch_regenerativ_gesamt',
        // 'verbrauch_waerme_kwh',
        'gesamtverbrauch',
        'verbrauch_renewable',
        'verbrauch_ohne_renewable',
        'waerme_kwh',
        'co2_fussabdruck_scope1',
        'co2_fussabdruck_scope2',
        'co2_fussabdruck_scope2_lb',
        'co2_fussabdruck_scope2_mb',
        'co2_fussabdruck_scope3',
        'co2_fussabdruck_scope1_scope2_lb',
        'co2_fussabdruck_scope1_scope2_mb',
        'co2_fussabdruck_total_lb',
        'co2_fussabdruck_total_mb',
    ];
    // console.log('kennziffern', JSON.stringify(kennziffern));
    const saveList: any[] = [];
    const scope3Structures: any[] = hasScope3 ? getScope3Structures(data) : [];
    const validierung: any = getValidierung(data);
    const vsme_export: any[] = data[IDs.ENT_VSME_EXPORT] || [];
    const curItems: any = {};
    vsme_export.forEach((item: any) => item.jahr ? curItems[item.jahr] = {} : null);

    Object.keys(validierung).forEach((key: string) => {
        if (!Object.keys(curItems[key] || {}).length && Number.isInteger(+key)) {
            curItems[key] = { ALL: {} };
        }
    });
    const items: any = { ...curItems, ...kennziffern_strukturiert };
    const jahre: number = Object.keys(items).length;
    const uuid: string = data[IDs.ENT_REGISTRIERUNG]?.[0]?.uuid || null;
    externalAccess.forEach((item: any) => (uuid && item.jahr && item.freigegeben === 1) ? isAvailable[item.jahr] = true : null);
    // console.log('kennziffernExport', 'items', JSON.stringify(items));
    Object.keys(items).forEach((jahr: string, index: number) => {
        const kennzahlen: any = {};
        const itemJahrDb: any = vsme_export.find((item: any) => +item.jahr === +jahr) || {};
        const kennzahlenJahrDb: string = itemJahrDb.kennzahlen || '{}';
        const plausibilisierung: any = {};
        const plausibilisierungJahrDb: string = itemJahrDb.plausibilisierung || null;
        const tid: number = itemJahrDb.tid || null;
        let delItem: boolean = false;

        if (+jahr < 2010) {
            return;
        }

        if ((!Object.keys(items[jahr] || {}).length && !validierung[jahr]) || !isAvailable[jahr]) {
            if (itemJahrDb.tid) {
                delList.push(itemJahrDb);
                console.log('delList', tid, jahr);
            }
            delItem = true;
        }

        Object.keys(items[jahr]).forEach((standort: string) => {
            if (standort === 'ALL' && Object.keys(items[jahr][standort] || {}).length) {
                kennzahlen.gesamt = {};
                keys.forEach((key: string) => kennzahlen.gesamt[key] = kennziffern[jahr]?.[key]);
                return;
            }

            if (standort !== 'ALL') {
                if (!kennzahlen.standorte) {
                    kennzahlen.standorte = {};
                }
                kennzahlen.standorte[standort] = {};
                keys.forEach((key: string) => kennzahlen.standorte[standort][key] = kennziffern_standort[standort]?.[jahr]?.[key]);
                const scope3Selected: string[] = getCO2Scope3Auswahl(data, { tid: +standort }, +jahr, +jahr);
                const scope3Systemboundaries: any[] = [];
                const scope3Items: any[] = (data[IDs.ENT_CO2_SCOPE3_AUSWAHL] || []).filter((item: any) =>
                    item.jahr === +jahr && item.standort_tid_orig === +standort && !item.auswahl
                    && ['emittenten', 'dokument'].indexOf(item.name) === -1
                );

                scope3Structures.forEach((structure: any) => {
                    if (scope3Selected.indexOf(structure.key) === -1 && (!structure.modus || structure.modus === 'ghg')) {
                        const item: any = scope3Items.find((item: any) => structure.key === item.name) || {};
                        scope3Systemboundaries.push({
                            id: structure.part ? [structure.subscope, structure.part].join('.') : structure.subscope?.toString(),
                            name: structure.name,
                            text: item.hinweis || null,
                        });
                    }
                });

                if (scope3Structures.length) {
                    kennzahlen.standorte[standort].scope3_systemboundaries = scope3Systemboundaries;
                }
            }

            if (!delItem) {
                (validierung._items || []).forEach((item: any) => {
                    if (item.jahr === +jahr) {
                        const entity: string = item.entity || null;
                        if (!plausibilisierung[entity]) {
                            plausibilisierung[entity] = [];
                        }
                        delete item.entity;
                        delete item.jahr;
                        plausibilisierung[entity].push(item);
                    }
                });
            }
        });
        const kennzahlenJahr: string = JSON.stringify(kennzahlen);
        const plausibilisierungJahr: string = Object.keys(plausibilisierung).length ? JSON.stringify(plausibilisierung) : null;

        // console.log('processKennzahlenExport', 'delItem', JSON.stringify(delItem), 'tid', tid);
        // console.log('processKennzahlenExport' , 'kennzahlenJahr', kennzahlenJahr)
        // console.log('processKennzahlenExport', 'plausibilisierungsJahr', plausibilisierungJahr);
        // console.log('processKennzahlenExport', 'kennzahlenJahrDb', kennzahlenJahrDb);
        if (!delItem && (!tid || kennzahlenJahr !== kennzahlenJahrDb || plausibilisierungJahr !== plausibilisierungJahrDb)) {
            saveList.push({ tid, jahr, kennzahlen: kennzahlenJahr, plausibilisierung: plausibilisierungJahr });
            console.log('saveList', tid, jahr);
        }

        if (index + 1 === jahre) {
            if (saveList.length && !IS_WRITING) {
                IS_WRITING = true;
                dataService.saveDataList(IDs.ENT_VSME_EXPORT, saveList, (sql: string, success: boolean) => {
                    if (delList.length) {
                        delData(delList);
                    } else {
                        if (success) {
                            data[IDs.ENT_VSME_EXPORT] = null;
                            triggerService.fire('reload', IDs.ENT_VSME_EXPORT);
                            // saveList.forEach((item: any) => {
                            //     triggerService.fire('updateLocalDataByEntity', 'dataObject', { [IDs.ENT_VSME_EXPORT]: item });
                            // });
                        }
                        onProcessDone();
                    }
                }, IDs.MOD_ETOOL);
            } else if (delList.length && !IS_WRITING) {
                IS_WRITING = true;
                delData(delList);
            } else {
                onProcessDone();
            }
        }
    });
}
